import React from 'react';

export const BackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7071 4.79289C13.0976 5.18342 13.0976 5.81658 12.7071 6.20711L6.41421 12.5L12.7071 18.7929C13.0976 19.1834 13.0976 19.8166 12.7071 20.2071C12.3166 20.5976 11.6834 20.5976 11.2929 20.2071L4.29289 13.2071C3.90237 12.8166 3.90237 12.1834 4.29289 11.7929L11.2929 4.79289C11.6834 4.40237 12.3166 4.40237 12.7071 4.79289Z"
      fill="var(--color-text-primary-alt)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12.5C4 11.9477 4.44772 11.5 5 11.5H19C19.5523 11.5 20 11.9477 20 12.5C20 13.0523 19.5523 13.5 19 13.5H5C4.44772 13.5 4 13.0523 4 12.5Z"
      fill="var(--color-text-primary-alt)"
    />
  </svg>
);
